import request from '../../../api/request';
import {
  FormResponse,
  LessonTeacherJustificationSubmitData,
  TeacherAttendanceResponse,
} from '../types';

const TEACHER_ATTENDANCE = {
  FORM: 'teacher-portal/teacher-attendance/form',
  LESSONS: 'teacher-portal/teacher-attendance/lessons-attendance',
  CREATE: (lessonId: number) =>
    `teacher-portal/teacher-attendance/${lessonId}/justification-attendance`,
};

export const getTeacherAttendanceForm = () =>
  request<FormResponse>(TEACHER_ATTENDANCE.FORM);

export const getTeacherAttendance = (
  items: number,
  page: number,
  sectionId?: number,
  classStatus?: string,
) => {
  return request<TeacherAttendanceResponse>(TEACHER_ATTENDANCE.LESSONS, {
    method: 'get',
    params: {
      items_per_page: items,
      page,
      sectionId,
      classStatus,
    },
  });
};

export const storeTeacherJustification = (
  data: LessonTeacherJustificationSubmitData,
) => {
  return request<void>(TEACHER_ATTENDANCE.CREATE(data.lessonId), {
    method: 'post',
    data: data,
  });
};

export const updateTeacherJustification = (
  data: LessonTeacherJustificationSubmitData,
) => {
  return request<void>(TEACHER_ATTENDANCE.CREATE(data.lessonId), {
    method: 'put',
    data: data,
  });
};
